__turbopack_context__.v({
  "center_button": "styles-module-scss-module__i84hQq__center_button",
  "grouped_images": "styles-module-scss-module__i84hQq__grouped_images",
});
